import {IFile} from "../../../core/models/ifile";

export class NovoDocumentoProcesso{
  descricao: string;
  tipo: number | null;
  arquivo: IFile;
  processo: number | null;
  pasta: number | null;
  caminho: string;
}
